module.exports = __webpack_public_path__ + "static/media/mpds_404-illustration.167dd4d6.svg";